function wallClockFormatter(timeZone: string) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
}

function formattedWallClock(formatter: Intl.DateTimeFormat, instant: Date): string {
  const parts = formatter.formatToParts(instant);
  const part = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}T${part('hour')}:${part('minute')}`;
}

export function businessWallClock(instant: Date, timeZone: string): string {
  return formattedWallClock(wallClockFormatter(timeZone), instant);
}

// datetime-local has no offset. Require exactly one instant matching the
// requested wall clock, rather than silently choosing one side of a DST fold.
export function businessWallClockToRFC3339(value: string, timeZone: string): string {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) {
    throw new Error('Enter a valid date and time.');
  }
  const guess = Date.parse(`${value}:00Z`);
  if (!Number.isFinite(guess)) throw new Error('Enter a valid date and time.');
  const formatter = wallClockFormatter(timeZone);
  const matches: string[] = [];
  // Modern IANA offsets use 15-minute increments, including Nepal and Chatham.
  for (let offset = -14 * 60; offset <= 14 * 60; offset += 15) {
    const instant = new Date(guess - offset * 60_000);
    if (formattedWallClock(formatter, instant) === value) matches.push(instant.toISOString());
  }
  if (matches.length !== 1) {
    throw new Error('This time is ambiguous or does not exist in the business timezone. Choose another time.');
  }
  return matches[0];
}
